import parse from "html-react-parser";
import { useLocation, useNavigate } from "react-router-dom";
import BackToHomeBtn from "../../components/BackToHomeBtn";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

const CancelConfirm = () => {
  useCookiesCheck();
  const navigate = useNavigate();
  const location = useLocation();
  const stateData: IReqDynamicCancellation = location.state.data;
  const parsedHtml = parse(
    stateData.data?.condition.replace("{0}", stateData.data?.amount) || ""
  );
  const { t } = useTranslation();

  const submitHandler = () => {
    navigate("/formCancellationData", {
      state: { data: stateData },
    });
  };

  return (
    <div className="container">
      <BackToHomeBtn />

      <div>{parsedHtml}</div>

      <button
        className="btn btn-warning text-white py-2 px-5 m-auto d-block mt-5"
        onClick={submitHandler}
      >
        {t("other.cancelNow")}
      </button>
    </div>
  );
};

export default CancelConfirm;
